class TeamRider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onHideClick = this.onHideClick.bind(this)

    this.listeners.add(this.els.hide.element, 'click', this.onHideClick)
  }

  onHideClick () {
    this.style.display = 'none'
  }
}

if (!customElements.get('team-rider')) {
  customElements.define('team-rider', TeamRider)
}
